module.exports = __webpack_public_path__ + "static/media/search-clear.f5575f46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/search-clear.svg
// module id = 6324
// module chunks = 1